/** Классификатор для RouterLink vs <a>: путь роутера или внешний URL. */
export const isAbsoluteUrl = (url: string) => {
  if (typeof url !== 'string') return false;
  return /^https?:\/\//i.test(url);
};

export const SAFE_HTTP_URL_ERROR_MESSAGE = 'Укажите корректную ссылку http:// или https://';

/** Валидация пользовательского ввода: только безопасный http/https. */
export const isSafeHttpUrl = (url: string): boolean => {
  if (typeof url !== 'string' || !url || /[<>"'`\\{}]/.test(url)) {
    return false;
  }

  try {
    const parsed = new URL(url);
    return (
      (parsed.protocol === 'http:' || parsed.protocol === 'https:') &&
      parsed.username === '' &&
      parsed.password === '' &&
      parsed.hostname.length > 0
    );
  } catch {
    return false;
  }
};

/** Для необязательных полей: пусто — ок. */
export const isEmptyOrSafeHttpUrl = (url: string | null | undefined) => {
  if (url == null || url === '') return true;
  return isSafeHttpUrl(url);
};
